/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Card,
  Typography,
  TextField,
  Box,
  Popper,
  Button,
  Grid,
  useMediaQuery,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Close, Search, ChevronRight } from "@mui/icons-material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import InfoIcon from "@mui/icons-material/Info";
import { homeService } from "../../services/home.service";

const InsuranceContainer = (props) => {
  const {
    insuranceData,
    selectedInsurance,
    saveInsuranceData,
    closeInsurance,
    insuranceZIndex,
    saveUserInsurance,
    contentInfo,
    updateGTMDataLayer,
    organizationInfo,
  } = props;

  const matches = useMediaQuery("(max-width:600px)");
  const matchesMinWidth = useMediaQuery("(max-width:400px)");
  const [showDefaultList, setShowDefaultList] = useState(false);
  const [showNoInsuranceInfo, setShowNoInsuranceInfo] = useState(false);
  const [insuranceHelpData, setInsuranceHelpData] = useState({});
  const [commericalInsuranceData, setCommericalInsuranceData] = useState({});
  const [govtInsuranceData, setGovtInsuranceData] = useState({});
  const [unInsuranceData, setUnInsuranceData] = useState({});
  const [unselectedInsuranceData, setUnselectedInsuranceData] = useState({});
  const [govtInsuranceAlertPopup, setGovtInsuranceAlertPopup] = useState(false);
  const [tempInsuranceData, setTempInsuranceData] = useState({});
  const [insuranceHelpDataUrl, setInsuranceHelpDataUrl] = useState("");
  const commercialInsurance = localStorage.getItem("commercialInsuranceValue");
  const isCommercialInsuranceValueUpdated = localStorage.getItem(
    "isCommercialInsuranceValueUpdated"
  );
  const [insuranceType, setInsuranceType] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [placeholderTxt, setplaceholderTxt] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [defaultInsuranceData, setDefaultInsuranceData] = useState(null);
  // const hasUserSelectedInsurance = localStorage.getItem(
  //   "hasUserSelectedInsurance"
  // );
  
  const getSelectedOption = (event, item) => {
    const isInsured = selectedInsurance;
    if (item.displayText) {
      item.name = item.displayText;
      item.id = item.value.id;
      item.type = item.value.type;
    }
    if (item) {
      saveInsuranceData(item);
      saveUserInsurance(item.id);
    }
    if (isInsured && (isInsured?.id || isInsured?.type === "Z") && item) {
      // resetData("insuranceReset");
    }
    setInsuranceType(null);
    closeInsurance("gauge");
    setShowDefaultList(false);

    updateGTMDataLayer({
      event: "Search_medication_select_insurance",
      insurance_type: insuranceType,
      insurance: item.name || "",
      page: "Search for medication",
      screen: "Select Insurance",
      screen_referrer: "Search for medication",
    });
  };

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    // getContentType("INSURANCE_HELP_V2");
    updateGTMDataLayer({
      event: "Search_medication_insurance_search",
      page: "Search for medication",
      screen: "Search Insurance",
      screen_referrer: "Search for medication",
    });
  }, []);

  useEffect(() => {
    if (insuranceType !== null) {
      setTimeout(() => {
        setplaceholderTxt(false);
      }, 4000);
    } else {
      setplaceholderTxt(true);
    }
  }, [insuranceType]);

  useEffect(() => {
    if (
      contentInfo &&
      contentInfo.INSURANCE_HELP_V2 &&
      contentInfo.INSURANCE_HELP_V2.content
    ) {
      setInsuranceHelpData(contentInfo.INSURANCE_HELP_V2);
      setInsuranceHelpDataUrl(contentInfo.INSURANCE_HELP_V2.content);
      const unInsured = contentInfo.INSURANCE_HELP_V2.contentParam.filter(
        (item) => item.value.type === "Z"
      )[0];
      const govtInsData = contentInfo.INSURANCE_HELP_V2.contentParam.filter(
        (item) => item.value.type === "Y"
      )[0];
      const commericalInsData =
        contentInfo.INSURANCE_HELP_V2.contentParam.filter(
          (item) => item.value.type === "X"
        )[0];
      const unselectedInsData =
        contentInfo.INSURANCE_HELP_V2.contentParam.filter(
          (item) => item.value.type === "W"
        )[0];
      setCommericalInsuranceData({
        ...commericalInsData?.value,
        formularyText: commericalInsData?.displayText,
        name: commericalInsData?.displayText,
      });
      setGovtInsuranceData({
        ...govtInsData?.value,
        formularyText: govtInsData?.displayText,
        name: govtInsData?.displayText,
      });
      setUnInsuranceData({
        ...unInsured?.value,
        formularyText: unInsured?.displayText,
        name: unInsured?.displayText,
      });
      setUnselectedInsuranceData({
        ...unselectedInsData?.value,
        formularyText: unInsured?.displayText,
        name: unInsured?.displayText,
      });
    }
  }, [contentInfo]);

  useEffect(() => {
    const commercialInsuranceValue = localStorage.getItem(
      "commercialInsuranceValue"
    );
    if (commercialInsuranceValue && isCommercialInsuranceValueUpdated === "Y") {
      insuranceHelpData?.contentParam?.forEach((element) => {
        if (element.key === commercialInsuranceValue) {
          getSelectedOption(null, element);
          setShowNoInsuranceInfo(false);
          localStorage.setItem("isCommercialInsuranceValueUpdated", "");
        }
      });
    }
  }, [commercialInsurance, isCommercialInsuranceValueUpdated]);

  useEffect(() => {
    if (insuranceType) {
      try {
        homeService.getInsutranceDefaultText(insuranceType).then((res) => {
          setDefaultInsuranceData(res?.data);
        });
      } catch (e) {
        console.log(e);
      }
    }
    return () => {
      setDefaultInsuranceData(null);
    };
  }, [insuranceType]);

  const insuranceSearch = (event) => {
    if (event?.target?.value && event.target.value.length > 2) {
      props.getInsutranceList(event.target.value);
    }
    if (!showDefaultList) {
      setShowDefaultList(true);
    }
    updateGTMDataLayer({
      event: "Search_medication_insurance_result",
      page: "Search for medication",
      screen: "Search Insurance",
      screen_referrer: "Search for medication",
    });
  };

  const notInsured = () => {
    getSelectedOption(null, {
      ...unInsuranceData,
    });
  };

  const handleOnFocus = () => {
    if (!showDefaultList) {
      setShowDefaultList(true);
    }
  };

  const PopperView = (prop) => {
    return (
      <Popper
        {...prop}
        className="insurance-popper"
        placement="bottom"
        style={{
          zIndex: insuranceZIndex,
          width: matches ? "80vw" : "30rem",
        }}
      />
    );
  };

  const clearCommercialInsurance = () => {
    localStorage.setItem("commercialInsuranceValue", "");
    localStorage.setItem("isCommercialInsuranceValueUpdated", "");
  };

  const closeInsuranceInfo = () => {
    setShowNoInsuranceInfo(false);
    localStorage.setItem("isCommercialInsuranceValueUpdated", "");
  };

  const clearSearches = () => {
    props.resetInsuranceFilterData();
    document.getElementById("clearIcon")?.parentElement?.click();
  };

  return (
    <Box sx={{ minHeight: 600, position: "relative" }} pt={matches ? 0 : 1}>
      <>
        <Card
          className="insurance-search-container"
          sx={{ width: matches ? "90vw" : undefined }}
        >
          {selectedInsurance?.id !== commercialInsurance?.id &&
            selectedInsurance?.id !== govtInsuranceData?.id &&
            selectedInsurance?.id !== unInsuranceData?.id && 
            selectedInsurance?.id !== unselectedInsuranceData?.id && (
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "30px",
                }}
                component={"div"}
                variant="h3LatoBold"
              >
                {selectedInsurance?.name}
              </Typography>
            )}
          <Autocomplete
            freeSolo
            id="insuranceSearchField"
            options={insuranceData}
            open={showDefaultList}
            onFocus={handleOnFocus}
            onBlur={() => {
              setShowDefaultList(false);
              clearSearches();
            }}
            getOptionLabel={(option) => option?.name || ""}
            className="auto-complete-input"
            PopperComponent={PopperView}
            clearIcon={
              <Close
                id="clearIcon"
                fontSize="small"
                onClick={() => clearSearches()}
              />
            }
            filterOptions={(all) => {
              return all;
            }}
            renderOption={(event, option, { inputValue }) => {
              const name = option.name.replace(
                new RegExp(inputValue, "gi"),
                (match) => `<b>${match}</b>`
              );
              return (
                <Box
                  className="auto-complete-list-container"
                  key={option.id}
                  id="insuranceSearchResult"
                  onClick={(temp) => {
                    if (option.type === "Y") {
                      setTempInsuranceData(option);
                      setGovtInsuranceAlertPopup(true);
                    } else {
                      clearCommercialInsurance();
                      getSelectedOption(temp, option);
                      props.resetInsuranceFilterData();
                    }
                    clearSearches();
                  }}
                >
                  <Box
                    className="search-list-view"
                    dangerouslySetInnerHTML={{ __html: name }}
                  ></Box>
                  <ChevronRight className="right-icon" />
                </Box>
              );
            }}
            renderInput={(params) => (
              <Box>
                <Typography
                  component={"div"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  variant="h3LatoBold"
                >
                  Enter your Insurance for best results:
                </Typography>
                <Box sx={{ position: "relative" }} mt={1}>
                  <TextField
                    id="insuranceSearchText"
                    name="insuranceSearchText"
                    {...params}
                    variant="standard"
                    onChange={insuranceSearch}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        if (e.key === "Enter" && insuranceData?.length) {
                          getSelectedOption(undefined, insuranceData[0]);
                        }
                      },
                    }}
                  />
                  <Search
                    sx={{
                      color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                    }}
                    className="search-icon"
                  />
                </Box>
              </Box>
            )}
          />
          <Box
            sx={{ float: "right", paddingTop: "10px" }}
            id="cantFindInsurance"
            onClick={() => {
              setShowNoInsuranceInfo(true);
              localStorage.setItem("isCommercialInsuranceValueUpdated", "");
            }}
          >
            <Typography
              variant="h5LatoBold"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Can't find your insurance? <InfoIcon />
            </Typography>
          </Box>
        </Card>

        <Box>
          <Dialog
            open={showNoInsuranceInfo}
            onClose={closeInsuranceInfo}
            className="app-dialog app-dialog-max-width"
            sx={{
              marginRight: matches ? undefined : "20%",
              marginLeft: matches ? undefined : "20%",
            }}
          >
            <DialogContent>
              <Box
                component="div"
                sx={{
                  textAlign: "center",
                }}
              >
                <Box>
                  <Box mb={2}>
                    <Typography
                      variant={matches ? "h3LatoBold" : "h2LatoBold"}
                      sx={{ lineHeight: matches ? "24px" : "26px" }}
                    >
                      {(contentInfo &&
                        contentInfo.INSURANCE_HELP_V2 &&
                        contentInfo.INSURANCE_HELP_V2.contentTitle) ||
                        null}
                    </Typography>
                  </Box>
                  <Box>
                    <iframe
                      title="insuranceContainer"
                      id={localStorage.getItem("commercialInsuranceValue")}
                      src={`${insuranceHelpDataUrl}?channel=${
                        matches ? "mobileweb" : "web"
                      }`}
                      frameBorder="0"
                      border="0"
                      cellSpacing="0"
                      style={{
                        height: matches ? "420px" : "462px",
                        borderStyle: "none",
                        width: "100%",
                      }}
                      scrolling="yes"
                    ></iframe>
                  </Box>
                  <Box my={matches ? 2 : 3}>
                    <Button
                      variant="large"
                      id="insuranceHelpdDoneBtn"
                      sx={{ minWidth: matches ? "166px" : undefined }}
                      onClick={() => {
                        setShowNoInsuranceInfo(false);
                      }}
                    >
                      Done
                    </Button>
                  </Box>
                </Box>
              </Box>
            </DialogContent>
          </Dialog>
        </Box>

        <Box>
          <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={govtInsuranceAlertPopup}
            // onClose={closeInsuranceInfo}
            className="app-dialog"
            sx={{
              marginRight: matches ? undefined : "20%",
              marginLeft: matches ? undefined : "20%",
            }}
          >
            <DialogContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Typography variant="h3LatoBold">
                  You have selected a Medicare/Medicaid/Govt plan.
                  <br />
                  Is this correct?
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="outline"
                  sx={{ fontFamily: "Lato-Bold", marginRight: "10px" }}
                  onClick={() => {
                    clearCommercialInsurance();
                    getSelectedOption(undefined, tempInsuranceData);
                    props.resetInsuranceFilterData();
                    setGovtInsuranceAlertPopup(false);
                    setTempInsuranceData({});
                  }}
                >
                  Yes
                </Button>
                <Button
                  variant="outline"
                  sx={{ fontFamily: "Lato-Bold" }}
                  onClick={() => {
                    setTempInsuranceData({});
                    setGovtInsuranceAlertPopup(false);
                  }}
                  // onClick={() => onCancel()}
                >
                  No, I'll reselect
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        </Box>
      </>
      <Card
        className="insurance-search-container"
        sx={{ width: matches ? "90vw" : undefined }}
      >
        <Grid item xs={12}>
          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "10px 10px 15px 10px",
              fontSize: matches ? 14 : 18,
            }}
            variant="h3LatoMedium"
          >
            If unable to select insurance, choose below:
          </Typography>
          <>
            {commericalInsuranceData?.id && (
              <Box sx={{ display: "flex", justifyContent: "center" }} mb={3}>
                <Button
                  onClick={() => {
                    saveInsuranceData({
                      ...commericalInsuranceData,
                    });
                    saveUserInsurance(commericalInsuranceData.id);

                    closeInsurance("gauge");

                    setInsuranceType(commericalInsuranceData?.type);
                    updateGTMDataLayer({
                      event: "Search_medication_insurance_search",
                      insurance_type: commericalInsuranceData?.type,
                      page: "Search for medication",
                      screen: "Change Insurance Type",
                      screen_referrer: "Search for medication",
                    });
                  }}
                  id="private"
                  sx={{
                    width: "405px !important",
                    fontSize: matches ? 14 : 16,
                    textTransform: "uppercase",
                    color:
                      selectedInsurance?.id === commericalInsuranceData?.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor} !important`
                        : "",
                    backgroundColor:
                      selectedInsurance?.id === commericalInsuranceData?.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor} !important`
                        : "",
                  }}
                  variant="filled"
                >
                  {commericalInsuranceData?.name}
                </Button>
              </Box>
            )}
          </>
          <>
            {govtInsuranceData?.id && (
              <Box sx={{ display: "flex", justifyContent: "center" }} mb={3}>
                <Button
                  onClick={() => {
                    saveInsuranceData({
                      ...govtInsuranceData,
                    });
                    saveUserInsurance(govtInsuranceData.id);

                    closeInsurance("gauge");
                    setInsuranceType(govtInsuranceData?.type);
                    updateGTMDataLayer({
                      event: "Search_medication_insurance_search",
                      insurance_type: govtInsuranceData?.type,
                      page: "Search for medication",
                      screen: "Select Insurance Type",
                      screen_referrer: "Search for medication",
                    });
                  }}
                  id="medicare"
                  sx={{
                    width: "405px !important",
                    fontSize: matches ? 14 : 16,
                    textTransform: "uppercase",
                    color:
                      selectedInsurance?.id === govtInsuranceData.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor} !important`
                        : "",
                    backgroundColor:
                      selectedInsurance?.id === govtInsuranceData.id
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor} !important`
                        : "",
                  }}
                  variant="filled"
                >
                  {govtInsuranceData?.name}
                </Button>
              </Box>
            )}
          </>
          <>
            {unInsuranceData?.id && (
              <Box sx={{ display: "flex", justifyContent: "center" }} mb={3}>
                <Button
                  id="unInsuredBtn"
                  sx={{
                    width: "405px !important",
                    fontSize: matches ? 14 : 16,
                    color:
                      selectedInsurance?.type === "Z"
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor} !important`
                        : "",
                    backgroundColor:
                      selectedInsurance?.type === "Z"
                        ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor} !important`
                        : "",
                    textTransform: "uppercase",
                  }}
                  variant="filled"
                  onClick={() => {
                    clearCommercialInsurance();
                    notInsured();
                    updateGTMDataLayer({
                      event: "Search_medication_uninsured",
                      insurance_type: "I'M CURRENTLY UNINSURED",
                      insurance: "I'M CURRENTLY UNINSURED",
                      page: "Search for medication",
                      screen: "Select Insurance Type",
                      screen_referrer: "Search for medication",
                    });
                  }}
                >
                  {unInsuranceData?.name}
                </Button>
              </Box>
            )}
          </>
        </Grid>
      </Card>
      <Grid
        sx={{ width: "100%", justifyContent: "center", display: "flex" }}
        item
        pt={2}
        xs={12}
      >
        <Typography
          sx={{ width: matchesMinWidth ? "90%" : "60%", textAlign: "center" }}
          variant="h3LatoRegular"
        >
          I do not wish to check if i am eligible for manufacture savings
          coupons, nor compare lowest available discount card pricing to my
          estimated copay, or see less expensive covered alternatives within my
          plan within my results
        </Typography>
      </Grid>
      <Grid
        sx={{ width: "100%", justifyContent: "center", display: "flex" }}
        item
        pt={2}
        xs={12}
      >
        <Button
          variant="outline"
          sx={{ minWidth: 330, fontFamily: "Lato-Bold" }}
          onClick={() => {
            closeInsurance("gauge", true);
            setInsuranceType(null);
            clearSearches();
          }}
        >
          CANCEL
        </Button>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    isProgress: state.insuranceList.isProgress,
    selectedInsurance: state.insuranceList.selectedInsurance,
    hasUserSelectedInsurance: state.insuranceList.hasUserSelectedInsurance,
    insuranceData: state.insuranceList.data || [],
    contentInfo: state.contentType.data,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getInsutranceList: (value, type) =>
    homeActions.getInsutranceList(value, type),
  saveInsuranceData: (value) => homeActions.saveInsuranceData(value),
  saveUserInsurance: (value) => homeActions.saveUserInsurance(value),
  resetData: (value) => homeActions.resetData(value),
  getContentType: (type) => homeActions.getContentType(type),
  resetInsuranceFilterData: () => homeActions.resetInsuranceFilterData(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceContainer);
